<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-bar-chart"></i> {{ $t('sales_report') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card-box">
                    <form @submit.prevent="doFilter()">
                        <div class="row">
                            <div class="col-xs-12 col-md-6 m-b-15 clearfix" :class="{'has-error': errors['created_at_from'], 'has-error': errors['created_at_to']}">
                                <label>{{ $t('created_at') }}</label>
                                <div class="input-daterange input-group">
                                    <pml-date-picker v-model="filter.created_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.created_at_to"></pml-date-picker>
                                </div>
                                <span class="error" v-if="errors['created_at_from']">{{ errors['created_at_from'][0] }}</span>
                                <span class="error" v-if="errors['created_at_to']">{{ errors['created_at_to'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-md-6 m-b-15 clearfix" :class="{'has-error': errors['closed_at_from'], 'has-error': errors['closed_at_to']}">
                                <label>{{ $t('sold_at') }}</label>
                                <div class="input-daterange input-group">
                                    <pml-date-picker v-model="filter.closed_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.closed_at_to"></pml-date-picker>
                                </div>
                                <span class="error" v-if="errors['closed_at_from']">{{ errors['closed_at_from'][0] }}</span>
                                <span class="error" v-if="errors['closed_at_to']">{{ errors['closed_at_to'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-md-4 m-b-15 clearfix" :class="{'has-error': errors['member_id']}">
                                <label>{{ $t('consultant') }}</label>
                                <pml-select-members v-model="filter.member_id" :onlyActive="true"></pml-select-members>
                                <span class="error" v-if="errors['member_id']">{{ errors['member_id'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-md-4 m-b-15 clearfix" :class="{'has-error': errors['source_id']}">
                                <label>{{ $t('source') }}</label>
                                <pml-select v-model="filter.source_id" :options="sources"></pml-select>
                                <span class="error" v-if="errors['source_id']">{{ errors['source_id'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-md-4 m-b-15 clearfix" :class="{'has-error': errors['source_id']}">
                                <label>{{ $t('segments') }}</label>
                                <pml-select v-model="filter.segment_id" :options="segments"></pml-select>
                                <span class="error" v-if="errors['source_id']">{{ errors['source_id'][0] }}</span>
                            </div>
                        </div>
                        <hr class="m-t-0">
                        <div class="clearfix">
                            <span class="btn btn-white pull-left" @click.prevent="clear"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>
                            <button class="btn btn_green pull-right" type="submit" v-pml-block="isLoading">
                                <span class="btn-label">
                                    <i class="fa fa-search"></i>
                                </span>
                                {{ $t('filter') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="row panels_info">
            <div class="col-sm-12 col-md-4">
                <div class="widget-panel widget-style-2 bg-white min_h_98">
                    <i class="ti-user text-primary"></i>
                    <h2 class="m-0 text-dark counter font-600">{{ dealsAmount }}</h2>
                    <div class="text-muted m-t-5">{{ $t('converted_deals') }}</div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="widget-panel widget-style-2 bg-white min_h_98">
                    <i class="md-attach-money text-custom"></i>
                    <h2 class="m-0 text-dark counter font-600">{{ totalSales | pmlFormatCurrencyById(tenant.currency_id) }}</h2>
                    <div class="text-muted m-t-5">{{ $t('total_value') }}</div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="widget-panel widget-style-2 bg-white min_h_98">
                    <i class="ti-ticket text-purple"></i>
                    <h2 class="m-0 text-dark counter font-600">{{ totalSales / dealsAmount | pmlFormatCurrencyById(tenant.currency_id) }}</h2>
                    <div class="text-muted m-t-5">{{ $t('average_ticket') }}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('sales_report') }}</h4>
                    <div v-pml-block="isLoading" style="min-height: 200px;">
                        <div style="height: 280px;" ref="salesReport" v-show="hasRegistry"></div>
                        <pml-ec-line v-if="!hasRegistry"></pml-ec-line>
                    </div>
                </div>
            </div>
        </div>
        <List :records="listedDeals" v-pml-block="isLoading" class="bg_load_null m-b-20"/>
    </master-layout>
</template>

<script>
    import c3 from 'c3'
    import { getSalesReport } from 'services/reports'
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'
    import List from '@/modules/reports/sales/components/List'

    export default {
        name: 'SalesReport',
        components: { List },
        data () {
            return {
                filter: {
                    type: 'daily',
                    closed_at_from: null,
                    closed_at_to: null,
                    created_at_from: null,
                    created_at_to: null,
                    member_id: '',
                    source_id: null,
                    segment_id: null
                },
                isLoading: false,
                dealsAmount: 0,
                totalSales: 0,
                listedDeals: [],
                chartData: {
                    data: []
                },
                errors: []
            }
        },
        metaInfo () {
            return {
                title: trans('sales_report')
            }
        },
        computed: {
            ...mapGetters({
                'types': 'getSalesReportTypes',
                'members': 'getMembers',
                'sources': 'getSources',
                'segments': 'getSegments',
                'tenant': 'getTenant'
            }),
            hasRegistry () {
                for (let i = 1; i < this.chartData.data.length; i++)
                    if (this.chartData.data[i] !== 0)
                        return true

                return false
            }
        },
        mounted () {
            this.clear()
            this.doFilter()
        },
        methods: {
            clear () {
                this.filter.source_id = null
                this.filter.segment_id = null
                this.filter.closed_at_from = moment().subtract(14, 'days').format('DD/MM/YYYY')
                this.filter.closed_at_to = moment().add(1, 'days').format('DD/MM/YYYY')
                this.filter.created_at_from = moment().subtract(14, 'days').format('DD/MM/YYYY')
                this.filter.created_at_to = moment().add(1, 'days').format('DD/MM/YYYY')
                this.errors = []
            },
            doFilter () {
                this.isLoading = true

                getSalesReport(this.filter)
                    .then(response => {
                        this.totalSales = response.data.total_sales
                        this.dealsAmount = response.data.total_deals
                        this.chartData = response.data.sales_report
                        this.listedDeals = response.data.listed_deals
                        this.errors = []
                        this.isLoading = false

                        let vm = this

                        c3.generate({
                            bindto: this.$refs.salesReport,
                            data: {
                                columns: [
                                    this.chartData.data
                                ],
                                type: 'area-spline',
                                colors: {
                                    Sales: '#5fbeaa'
                                }
                            },
                            tooltip: {
                                format: {
                                    value (value, ratio, id, index) {
                                        return vm.$options.filters.pmlFormatCurrencyById(value, vm.tenant.currency_id)
                                    }
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    categories: this.chartData.period
                                }
                            }
                        })
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/sales/components/Main.vue